import { FC, PropsWithChildren } from 'react';
import styles from './Controls.css';

export const Controls: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles['controls']}>{children}</div>;
};
